/**
 * Container component that renders a chart for each selected element
 */
import { Stack, Text, Alert } from '@mantine/core';
import { ElementChart } from './ElementChart';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import type { ElementHistoryResponse } from '@/types/sensor';

interface ElementChartViewProps {
  data: ElementHistoryResponse;
}

export function ElementChartView({ data }: ElementChartViewProps) {
  if (data.elements.length === 0) {
    return (
      <Text c="dimmed" ta="center" py="lg">
        No history data available for selected elements.
      </Text>
    );
  }

  return (
    <Stack gap="md" data-testid="chart-stack">
      {data.elements.map((element) => (
        <ErrorBoundary
          key={element.element}
          fallback={
            <Alert color="red" title={`${element.label} chart error`}>
              Failed to render chart. Please try refreshing the page.
            </Alert>
          }
        >
          <ElementChart data={element} />
        </ErrorBoundary>
      ))}
    </Stack>
  );
}
